import type { TypePolicies } from '../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  NotificationGroupConnection: {
    fields: {
      timestamp: (existing) => {
        return existing ?? null;
      },
    },
  },
};
